<div class="text-center ">
  <div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <h3 class="text-success">
      <strong *ngIf="mode=='Book'" >Thank you for {{ButtonName}}</strong>
      <strong *ngIf="mode=='Prepay'">Thank you for {{ButtonName}}</strong>
      <strong *ngIf="mode=='Quote'">Thank you</strong>
      <strong *ngIf="mode=='Order'">Thank you for ordering</strong>
    </h3>
  </div>
  <h5 class="p-4" *ngIf="mode=='Book'">
    {{ButtonName}} has been successfully submitted for approval.<br>
    <span *ngIf="DownloadButtonVisible && splits && splits.length > 0"  [attr.id]="'ta-book-'+splits[0].TransactionMessage"> Your booking is created at  {{splits[0].CreatedDateTime}}</span> 
    <div *ngFor="let split of splits">
      <span *ngIf="!DownloadButtonVisible"  [attr.id]="'ta-book-'+split.TransactionMessage"> Your booking # {{split.TransactionMessage}} at  {{split.CreatedDateTime}}</span> 
    </div>
    <br>
    <span *ngIf="splits == undefined"  [attr.id]="'ta-book-'+bookingReceiptNumber"> Your booking # {{bookingReceiptNumber}} at  {{createdDateTime}}</span> 

  </h5>
  <h5 class="p-4" *ngIf="mode=='Prepay'">
    {{ButtonName}} has been successfully submitted for approval.
    <span *ngIf="DownloadButtonVisible && splits && splits.length > 0"  [attr.id]="'ta-book-'+splits[0].TransactionMessage"> Your booking is created at  {{splits[0].CreatedDateTime}}</span> 
    <div *ngFor="let split of splits">
      <span *ngIf="!DownloadButtonVisible"  [attr.id]="'ta-book-'+split.TransactionMessage"> Your prepay # {{split.TransactionMessage}}  at  {{split.CreatedDateTime}}</span> 
    </div>
    <br>
    <span *ngIf="splits == undefined"  [attr.id]="'ta-book-'+bookingReceiptNumber"> Your prepay # {{bookingReceiptNumber}} at  {{createdDateTime}}</span> 
  </h5>
  <h5 class="p-4" *ngIf="mode=='Quote'">
    {{ButtonName}} was saved successfully.
    <div *ngFor="let split of splits">
     <span *ngIf="!DownloadButtonVisible" class="ta-complete-download" [attr.id]="'ta-book-'+split.TransactionMessage"> Your Quote # {{split.TransactionMessage}}  at {{split.CreatedDateTime}}</span> 
    </div>
    <br>
    <span *ngIf="splits == undefined"  [attr.id]="'ta-book-'+bookingReceiptNumber"> Your Quote # {{bookingReceiptNumber}} at  {{createdDateTime}}</span> 
  </h5>
  <h5 class="p-4" *ngIf="mode=='Order'">
    Order has been successfully submitted for approval.
  </h5>
  <h5 class="p-4" *ngIf="mode=='Order'" class="ta-book-document">
    Your Sales Order #: {{bookingReceiptNumber}} at {{createdDateTime}}
  </h5>
  <!-- <h5 class="p-4" *ngIf="mode=='Prepay'">
    Your Prepay #: {{bookingReceiptNumber}}
  </h5>
  <h5 class="p-4" *ngIf="mode=='Book'">
    Your Booking #: {{bookingReceiptNumber}}
  </h5>
  <h5 class="p-4" *ngIf="mode=='Quote'">
    Your Quote #: {{bookingReceiptNumber}}
  </h5> -->
  <!-- <a class="btn btn-info btn-sm" ngxClipboard cla [class.btn-success]="isCopied" [cbContent]="bookingReceiptNumber" (cbOnSuccess)="isCopied = true">
    Copy
  </a>-->
  <br>
  <br>
  <div *ngIf="!isSplit">
    <div *ngIf="mode=='Prepay' || mode=='Book'">
      <button  *ngIf="DownloadButtonVisible && !DownloadButtonDisable"   mat-button class="ta-complete-download magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" (click)="DownloadPDF(bookingID)" >Download - {{documentNumber}}</button>
      <button mat-button class=" ta-booking-home magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" routerLink="/">Home</button>
      <button mat-button class="ta-booking-addnewdeal magin_5 btn btn-success text-white" routerLink="/booking">Add new deal</button>
    </div>
    <div *ngIf="mode=='Quote'">
      <button *ngIf="DownloadButtonVisible && !DownloadButtonDisable"  mat-button class="ta-complete-download magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" (click)="DownloadPDF(bookingID)" >Download - {{documentNumber}}</button>
      <button mat-button class="ta-booking-home magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" routerLink="/">Home</button>
      <button mat-button class="ta-booking-viewquotes magin_5 btn btn-success text-white" routerLink="/quotes">View {{this.ButtonName}}</button>
    </div>
    <div *ngIf="mode=='Order'">
      <button *ngIf="DownloadButtonVisible && !DownloadButtonDisable"  mat-button class="ta-complete-download magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" (click)="DownloadPDF(bookingID)" >Download - {{documentNumber}}</button>
      <button mat-button class="ta-booking-home mat-stroked-button-WhiteBackground-GreenText color_green font_bold" routerLink="/">Home</button>
      <button mat-button class="ta-booking-addnewdeal magin_5 btn btn-success text-white" routerLink="/order">Add new deal</button>
    </div>
  </div>
  <div *ngIf="isSplit">
      <div *ngIf="mode=='Prepay' || mode=='Book'">
        <button mat-button class=" ta-booking-home magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" routerLink="/">Home</button>
        <button mat-button class="ta-booking-addnewdeal magin_5 btn btn-success text-white" routerLink="/booking">Add new deal</button>
      </div>
      <div *ngIf="mode=='Quote'">
        <button mat-button class="ta-booking-home magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" routerLink="/">Home</button>
        <button mat-button class="ta-booking-viewquotes magin_5 btn btn-success text-white" routerLink="/quotes">View {{this.ButtonName}}</button>
      </div>
      <div *ngIf="mode=='Order'">
        <button mat-button class="ta-booking-home mat-stroked-button-WhiteBackground-GreenText color_green font_bold" routerLink="/">Home</button>
        <button mat-button class="ta-booking-addnewdeal magin_5 btn btn-success text-white" routerLink="/order">Add new deal</button>
      </div>
    <div *ngFor="let split of splits">
      <button *ngIf="DownloadButtonVisible && !DownloadButtonDisable"  [attr.id]="'ta-book-'+split.TransactionMessage" mat-button class="ta-booking-home magin_5 mat-stroked-button-WhiteBackground-GreenText color_green font_bold" (click)="DownloadPDF(split.TransactionObject.Data,split.TransactionObject.BookingNumber? split.TransactionObject.BookingNumber : split.Document)">Download - {{split.TransactionObject.BookingNumber? split.TransactionObject.BookingNumber : split.Document}}</button>
    </div>
  </div>
</div>